// extracted by mini-css-extract-plugin
module.exports = {"flag32":"Accordion_flag32__V6oZM","itemChild":"Accordion_itemChild__LtomW"};